import React, {createContext, useState} from "react";
import {IntlProvider} from "react-intl"

import Italian from '../../languages/it-IT.json'
import English from '../../languages/en-GB.json'

export const Context = createContext();

const localLang = navigator.language;

let lang;
if(localLang === "it-IT" || localLang === "it"){
  lang = Italian
} else {
  lang=English
}


const LanguageWrapper = ({children}) => {

    const [locale, setLocale] = useState(localLang)
    const [messages, setMessages] = useState(lang)

    function selectLanguage(e) {
        const newLocale = e.target.value;
        setLocale(newLocale)
        if(newLocale === "it-IT"){
            setMessages(Italian)
        } else {
            setMessages(English)
        }
    }
    
    return (
        <Context.Provider value={{locale,selectLanguage}} locale={locale}>
            <IntlProvider locale={locale} messages={messages} defaultLocale="en">
            {children}
            </IntlProvider>
        </Context.Provider>
    )

}

export default LanguageWrapper